<template>
    <div class="min_box">
        <p style="margin-bottom: 15px;color: rgba(0,0,0,.65)">终端访问量占比多的饼图分析</p>
        <div class="canvas">
            <CakeChart  :data="datas" :id="ids"></CakeChart>
        </div>
        <div class="flex" >
            <div>
                <a-button class="top_btn" type="primary"   @click="exportList()"  >批量导出</a-button>
                <span style="margin-left: 8px">
                    <template v-if="hasSelected">
                    {{ `选中 ${selectedRowKeys.length} 项` }}
                    </template>
                </span>
            </div>
            <div class="search-group flex">
                <a-input  v-model="search.name" class="search-input" allowClear placeholder="请输入客户名称搜索" />
                <a-button type="primary" class="top_btn" @click="getList()">搜索</a-button>
            </div>
        </div>
       <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"  >

        </a-table>

    </div>
</template>

<script>
    import Seach from "../components/seach"
    import CakeChart from "../components/cakeChart"
    import API from "./api";
    const columns = [
        {
            title: "客户名称",
            key: "company",
            ellipsis: true,
            dataIndex: "company",
        },
        {
            title: "PC(UV)",
            key: "pc_uv",
            ellipsis: true,
            dataIndex: "pc_uv",
            sorter: true,
        },
        {
            title: "移动(UV)",
            key: "yd_uv",
            ellipsis: true,
            dataIndex: "yd_uv",
            sorter: true,
        },
        {
            title: "PC占比(UV)",
            key: "pc_uv_rate",
            ellipsis: true,
            dataIndex: "pc_uv_rate",
            sorter: true,
        }
    ];
    export default {
        name: "index",
        data(){
            return{
                num:"2",
                id: this.$route.query.id,
                datas:[],
                data:[],
                list:[],
                selectedRowKeys:[],
                ids:"sourcea",
                columns,
                search:{
                    name:"",
                    order_field:"",
                    order_sort:""
                },
                page:"",
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
            }
        },
        components:{Seach,CakeChart},
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/VisitTerminal"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods:{
            handleChange(pagination, filters, sorter) {
                // this.filteredInfo = filters;
                // this.sortedInfo = sorter;
                if(sorter.order) {
                    let sort=sorter.order=="ascend"?"ASC":"DESC"
                    this.search.order_field=sorter.columnKey
                    this.search.order_sort=sort
                }else{
                    delete this.search.order_field
                    delete this.search.order_sort
                }
                let seachData = JSON.parse(JSON.stringify(this.search))
                this.name=this.search.name
                API.service.GET_LIST({page: this.page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },
            getDetail() {
                API.service.SOURCE_GET_LIST().then(res => {
                    this.datas=res.data.data
                })
            },
            exportList(){
                let seachData = JSON.parse(JSON.stringify(this.search))
                API.service.EXPORT({ids:this.selectedRowKeys ,page:this.page, ...seachData}).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                })
            },
            getList(page) {
                this.page=page
                let seachData = JSON.parse(JSON.stringify(this.search))
                this.name=this.search.name
                // console.log(seachData);
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
        },
        mounted() {
            this.getDetail()
            this.getList()
        }

    }
</script>

<style scoped>
    .title{font-weight: bold;font-size:18px;margin-bottom: 20px}
    .chart{margin-top:40px;width: 60%;position: relative;left: 10px}
    .list_box{border: 1px solid #f1f1f1;padding: 10px 16px;box-sizing: border-box;margin-top:40px;width: 38%}
    .list_box .list{line-height: 2;color: rgba(0, 0, 0, 0.65);width: 100%;}
    .list_box .top{border-bottom: 1px solid #f1f1f1;margin-bottom: 20px}
    .list_box .top i{color:#3a5a97}
    .list_box .title2{text-align: center;color: #3a5a97;font-weight: bold}
    .min_box{width: 70%}
    .canvas{max-width: 70%;}
    .search-group {
        float: right;
    }
    .search-group .ant-input {
        width: 200px;
        margin: 0 8px 0 0 ;
    }
    .search-group .search-input {
        width: 200px;height: 32px;
        margin: 0 8px 0 0 ;
    }
</style>
